<template>
  <div class="mobile-header">
    <div class="mobile-logo">
      <i class="el-icon-menu" style="height: 34px;width: 34px;font-size: 34px; color: #be3c6e;" @click="openMenu"></i>
    </div>
    <div class="title">
      <!-- <img class="logo" src="@/assets/img/home/foshologo2.png" alt=""> -->
      {{ menuTitle }}
    </div>

    <div class="menu">
      <el-dropdown @command="handleCommand" trigger="click">
        <el-avatar :src="getUserInfo.headImgUrl ? getUserInfo.headImgUrl : headImg"></el-avatar>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command="info">个人中心</el-dropdown-item> -->
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>

    <el-drawer title="" :visible.sync="drawer" :with-header="false" direction="ltr" :modal="false" :size="200">
      <div>
        <div class="header-logo">
          <img class="logo" src="@/assets/img/info/info_icon.png" alt="">
        </div>
        <el-menu :default-active="active" class="el-menu-vertical-drawer" background-color="#fff" text-color="#303133"
          active-text-color="#be3c6e" @select="selectMenu" :unique-opened="true">
          <el-menu-item index="starbrand-m">
            <i class="el-icon-s-flag"></i>
            <span slot="title">标杆品牌</span>
          </el-menu-item>
          <el-menu-item index="insight-m">
            <i class="el-icon-s-data"></i>
            <span slot="title">行业洞察</span>
          </el-menu-item>
          <el-menu-item index="brands-m">
            <i class="el-icon-s-marketing"></i>
            <span slot="title">品牌情报</span>
          </el-menu-item>
          <el-menu-item index="follow-m">
            <i class="el-icon-star-on"></i>
            <span slot="title">我的关注</span>
          </el-menu-item>
          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-message"></i>
              <span>邮箱建联</span>
            </template>
            <el-menu-item index="mailcenter-m">邮件中心</el-menu-item>
            <el-menu-item index="inbox-m">收件箱</el-menu-item>
            <el-menu-item index="outbox-m">发件箱</el-menu-item>
            <el-menu-item index="starMark-m">星标邮件</el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>多平台管理</span>
            </template>
            <el-menu-item index="authorization-m">授权中心</el-menu-item>
            <el-menu-item index="bulletinBoard-m">综合看板</el-menu-item>
            <el-menu-item index="report-m">报告详情</el-menu-item>
          </el-submenu>
          <el-menu-item index="aispark-m">
            <i class="el-icon-connection"></i>
            <span slot="title">联盟交易</span>
          </el-menu-item>
        </el-menu>
      </div>
    </el-drawer>

    <pc-tips ref="pctips"></pc-tips>
  </div>
</template>
<script>
import { setLocaData, getLocaData } from '@/utils/common'
import { QUERY, EXIT, PERMITS, RECORDS } from "../api/personal";
import { mapActions, mapGetters } from "vuex";
import pcTips from '@/views/mobile/components/pcTips'
export default {
  components: {
    pcTips
  },
  data() {
    return {
      drawer: false,
      active: this.$route.path.substr(1),
      headImg: require('../assets/img/default.png')
    };
  },
  created() { // 创建vm实例后执行
    this.queryUserInfo()
  },
  mounted() {

  },
  computed: {
    ...mapGetters(['getUserInfo','getHeaderTitle']),
    menuTitle() {
      if (this.$route.name === '行业洞察' || this.$route.name === '品牌情报') {
        const title = this.$route.name + ' - ' + this.getHeaderTitle
        return title
      } else {
        const title = this.$route.name
        return title
      }
    },
    menuIndex() {
      const path = this.$route.path
      return path.substr(1)
    }
  },
  methods: {
    ...mapActions(['changeUserInfo']),
    openMenu() {
      this.drawer = true
    },
    queryUserInfo() {
      QUERY().then(res => {
        if (res.data.code == 'success') {
          let userInfo = res.data.body
          this.changeUserInfo(userInfo)
        } else {
          this.$message({
            message: '获取用户信息失败',
            type: 'error'
          });
        }
      })
    },
    handleCommand(command) {
      if (command === 'logout') {
        EXIT().then(res => {
          if (res.data.code == 'error') {
            this.$message.error(res.data.msg)
          } else {
            this.$bus.$emit('noLogin', false)
            localStorage.clear();
            this.$router.push('/')
          }
        })
      }
    },
    selectMenu(index, pathIndex) {
      if (index === 'aispark-m') {
        this.active = this.$route.path.substr(1)
        this.drawer = false
        this.$refs.pctips.dialogVisible = true
      } else {
        this.$router.push(index)
        this.drawer = false
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mobile-header {
  height: 100%;
  display: flex;
  // display: -moz-box;
  /* Firefox 17- */
  // display: -webkit-flex;
  /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */
  // display: -moz-flex;
  /* Firefox 18+ */
  // display: -ms-flexbox;
  /* IE 10 */
  padding: 8px;
  // justify-content: space-between;
  // -webkit-box-pack: justify;
  // -ms-justify-content: space-between;
  // -moz-justify-content: space-between;
  // -o-justify-content: space-between;
  // -webkit-justify-content: space-between;
  // -webkit-justify-content: space-between;

  .mobile-logo {
    display: flex;
    width: 25%;
    height: 100%;

    img {
      height: 100%;
    }
  }

  .title {
    line-height: 34px;
    width: 50%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    img {
      height: 100%;
      vertical-align: baseline;
    }
  }

  .menu {
    width: 25%;
    text-align: right;

    /deep/.el-avatar {
      width: 34px;
      height: 34px;
    }
  }
}

.header-logo {
  height: 50px;
  padding: 8px;
  box-sizing: border-box;

  img {
    height: 100%;
  }
}

.el-menu-vertical-drawer {

  /dee/ .is-active {
    background-color: #be3c6e !important;
  }

  /dee/ .el-menu-item:hover {
    background-color: #be3c6e !important;
  }

  /deep/ .el-submenu__title {
    padding-left: 20px !important;
    background-color: #fff !important;
  }
}
</style>